<div *ngIf='tabList' [ngClass]='className' >
    <div class="title"  >
        <span class="titleName" *ngFor="let item of tabList,let i=index" (click)="tab(i)" [ngClass]="i==tabNum? 'active':'' " >{{item}}</span>
        <div id="slide"></div>
    </div> 
</div>


// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-social-tab/tab.html